import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type TranscriptionEncodeStatus_AudioAsset_Fragment = { __typename?: 'AudioAsset', id: string, localeTranscriptions?: { __typename?: 'TranscriptionConnection', nodes: Array<{ __typename?: 'Transcription', id?: string | null, encodeStatus: Types.EncodeStatusEnum, source?: Types.TranscriptionSource | null }> } | null };

export type TranscriptionEncodeStatus_DocumentAsset_Fragment = { __typename?: 'DocumentAsset', id: string };

export type TranscriptionEncodeStatus_FileAsset_Fragment = { __typename?: 'FileAsset', id: string };

export type TranscriptionEncodeStatus_FolderAsset_Fragment = { __typename?: 'FolderAsset', id: string };

export type TranscriptionEncodeStatus_ImageAsset_Fragment = { __typename?: 'ImageAsset', id: string };

export type TranscriptionEncodeStatus_InteractiveAsset_Fragment = { __typename?: 'InteractiveAsset', id: string };

export type TranscriptionEncodeStatus_InteractiveLiveAsset_Fragment = { __typename?: 'InteractiveLiveAsset', id: string };

export type TranscriptionEncodeStatus_ModelAsset_Fragment = { __typename?: 'ModelAsset', id: string };

export type TranscriptionEncodeStatus_UnsupportedAsset_Fragment = { __typename?: 'UnsupportedAsset', id: string };

export type TranscriptionEncodeStatus_VersionStackAsset_Fragment = { __typename?: 'VersionStackAsset', id: string };

export type TranscriptionEncodeStatus_VideoAsset_Fragment = { __typename?: 'VideoAsset', id: string, localeTranscriptions?: { __typename?: 'TranscriptionConnection', nodes: Array<{ __typename?: 'Transcription', id?: string | null, encodeStatus: Types.EncodeStatusEnum, source?: Types.TranscriptionSource | null }> } | null };

export type TranscriptionEncodeStatusFragment = TranscriptionEncodeStatus_AudioAsset_Fragment | TranscriptionEncodeStatus_DocumentAsset_Fragment | TranscriptionEncodeStatus_FileAsset_Fragment | TranscriptionEncodeStatus_FolderAsset_Fragment | TranscriptionEncodeStatus_ImageAsset_Fragment | TranscriptionEncodeStatus_InteractiveAsset_Fragment | TranscriptionEncodeStatus_InteractiveLiveAsset_Fragment | TranscriptionEncodeStatus_ModelAsset_Fragment | TranscriptionEncodeStatus_UnsupportedAsset_Fragment | TranscriptionEncodeStatus_VersionStackAsset_Fragment | TranscriptionEncodeStatus_VideoAsset_Fragment;

export const TranscriptionEncodeStatus = /*#__PURE__*/ gql`
    fragment TranscriptionEncodeStatus on Asset {
  id
  ... on AudioAsset {
    localeTranscriptions(page: {first: 100}) {
      nodes {
        id
        encodeStatus
        source
      }
    }
  }
  ... on VideoAsset {
    localeTranscriptions(page: {first: 100}) {
      nodes {
        id
        encodeStatus
        source
      }
    }
  }
}
    ` as unknown as DocumentNode<TranscriptionEncodeStatusFragment, unknown>;

        

        
export const useTranscriptionEncodeStatusFragment = (
  input: string | Omit<UseFragmentOptions<TranscriptionEncodeStatusFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'Asset' } };
    return input;
  })();

  return useFragment<TranscriptionEncodeStatusFragment>({
    fragment: TranscriptionEncodeStatus,
    fragmentName: 'TranscriptionEncodeStatus',
    ...options,
  });
};
  
        